import { useVolume } from '@/scenarios/legacy-player/hooks/useVolume';
import { MAX_VOLUME, MIN_VOLUME } from '@/scenarios/legacy-player/constants/volume';
import { useKeyboard } from '@/shared/hooks/useKeyboard';

import { VOLUME_STEP } from '../../../../../../constants/skin';

export const useSliderKeyboard = (slider: HTMLDivElement | null) => {
    const { setVolume, changeVolumeByStep } = useVolume();

    const volumeDown = (event: KeyboardEvent) => {
        changeVolumeByStep(-VOLUME_STEP);
        event.preventDefault();
    };
    const doubleVolumeDown = (event: KeyboardEvent) => {
        changeVolumeByStep(-2 * VOLUME_STEP);
        event.preventDefault();
    };
    const volumeUp = (event: KeyboardEvent) => {
        changeVolumeByStep(VOLUME_STEP);
        event.preventDefault();
    };
    const doubleVolumeUp = (event: KeyboardEvent) => {
        changeVolumeByStep(2 * VOLUME_STEP);
        event.preventDefault();
    };
    const volumeMin = (event: KeyboardEvent) => {
        setVolume(MIN_VOLUME);
        event.preventDefault();
    };
    const volumeMax = (event: KeyboardEvent) => {
        setVolume(MAX_VOLUME);
        event.preventDefault();
    };

    useKeyboard({
        target: slider,
        onLeft: volumeDown,
        onDown: volumeDown,
        onRight: volumeUp,
        onUp: volumeUp,
        onHome: volumeMin,
        onEnd: volumeMax,
        onPageDown: doubleVolumeDown,
        onPageUp: doubleVolumeUp,
    });
};
